import { AndroidLogo, AppleLogo, Circle } from '@phosphor-icons/react';
import { Button, Card, Flex, Spin, Tag, Typography } from 'antd';
import styled from 'styled-components';
import { ColoredPill, ColorText } from '../../elements';
import { CommonUtility, DateUtility, theme } from '../../utility';
import { useAppVersion } from '../../hooks';

const StatusPill = styled(ColoredPill)`
  height: 24px;
  padding: 0 10px;
`;

export function WaveStatusRenderer({ status }) {
  const statusColor = {
    building: theme.colors.orange,
    ready: theme.colors.accent,
    completed: theme.colors.green,
    in_progress: theme.colors.purple,
    sorting: theme.colors.lightBlack,
    sorted: theme.colors.lightGrey,
    cancelled: theme.colors.red,
  };

  if (['cancelled'].includes(status)) {
    return <Tag color={theme.colors.grey}>{CommonUtility.toTitleCase(status)}</Tag>;
  }

  if (['ready', 'completed', 'sorted'].includes(status)) {
    return <Tag color={theme.colors.green}>{CommonUtility.toTitleCase(status)}</Tag>;
  }

  return <Tag color={statusColor[status]}>{CommonUtility.toTitleCase(status)}</Tag>;
}

export function OrderTime({ time, isEnabled }) {
  let timeColor = '';
  const noOfDays = DateUtility.noOfDays(time);
  if (isEnabled) {
    if (noOfDays < 1) {
      timeColor = theme.colors.green;
    } else if (noOfDays <= 2) {
      timeColor = theme.colors.yellow;
    } else if (noOfDays <= 5) {
      timeColor = theme.colors.orange;
    } else if (noOfDays > 5) {
      timeColor = theme.colors.danger;
    }
  }
  return (
    <ColorText color={timeColor}>
      <b>{DateUtility.hourMinuteTime(time)}</b>
    </ColorText>
  );
}

export function MobileApplicationBanner() {
  const { data: mobileAppData, loading } = useAppVersion();

  return (
    <Card size="small" style={{ marginBottom: 8 }}>
      <Flex justify="space-between" align="center" gap={16}>
        <Flex vertical gap={4}>
          <Typography.Text>Mobile App Required for Wave Picking</Typography.Text>
          <Typography.Text type="secondary">
            Desktop portal is for allocation management only. Download the mobile app to
            pick and sort inventory.
          </Typography.Text>
        </Flex>
        <Flex gap={8} align="center">
          {loading ? (
            <Spin size="small" />
          ) : (
            <>
              {mobileAppData?.ios?.downloadLink && (
                <Button
                  href={mobileAppData.ios.downloadLink}
                  target="_blank"
                  rel="noreferrer"
                  icon={<AppleLogo size={15} />}
                >
                  Download for iOS
                </Button>
              )}
              {mobileAppData?.android?.downloadLink && (
                <Button
                  href={mobileAppData.android.downloadLink}
                  target="_blank"
                  rel="noreferrer"
                  icon={<AndroidLogo size={15} />}
                >
                  Download for Android
                </Button>
              )}
            </>
          )}
        </Flex>
      </Flex>
    </Card>
  );
}
